{
  "name": "@ns/checklist",
  "version": "1.0.0",
  "authorable": true,
  "description": "Someone works through a list and confirms it's done, or says why they can't.",
  "inputs": {
    "CONFIG": {
      "type": "object"
    }
  },
  "outcomes": {
    "done": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    },
    "cannotComplete": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    }
  },
  "config": {
    "instructions": {
      "kind": "longText",
      "label": "Instructions"
    },
    "items": {
      "kind": "list",
      "keyed": true,
      "label": "Items",
      "required": true,
      "of": {
        "label": {
          "kind": "text",
          "label": "Item",
          "required": true
        }
      }
    },
    "allRequired": {
      "kind": "boolean",
      "label": "Every item must be ticked",
      "default": true
    },
    "confirm": {
      "kind": "text",
      "label": "Confirmation statement"
    }
  },
  "answers": {
    "done": {
      "checked": {
        "keysOf": "items",
        "allIf": "allRequired"
      },
      "confirmed": {
        "kind": "boolean",
        "requiredIf": "confirm"
      }
    },
    "cannotComplete": {
      "reason": {
        "kind": "longText",
        "required": true
      }
    }
  }
}
